<div class="card center-div">
  <span class="header-text">{{header}}</span>
</div>
